var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-snackbar",
    {
      attrs: {
        "md-duration": _vm.snackbar.isInfinity
          ? Infinity
          : _vm.snackbar.duration,
        "md-active": _vm.snackbar.visible,
        "md-persistent": ""
      },
      on: {
        "update:mdActive": function($event) {
          return _vm.$set(_vm.snackbar, "visible", $event)
        },
        "update:md-active": function($event) {
          return _vm.$set(_vm.snackbar, "visible", $event)
        }
      }
    },
    [
      _c("span", [_vm._v(_vm._s(_vm.snackbar.message))]),
      _vm._v(" "),
      _c(
        "md-button",
        {
          staticClass: "md-primary snackbar-close",
          on: {
            click: function($event) {
              _vm.snackbar.visible = false
            }
          }
        },
        [_vm._v("schließen")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-41ba2ce1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41ba2ce1","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/notification/Notification.vue
// module id = null
// module chunks = 